import './Header.css';

export function Header() {
  return (
    <header className="Header">
      <div className="Header-brand">
        <img
          src="/logo.png"
          className="Header-logo"
          alt="PEI Power Logo"
        />
        <div className="Header-brandText">
          <h1>PEI Power</h1>
          <p>Tracking power outages, consumption, and generation across PEI.</p>
        </div>
      </div>
      <a
        className="Header-kofiButton"
        href="https://ko-fi.com/G2G01PRJF4"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          height="36"
          src="https://storage.ko-fi.com/cdn/kofi6.png?v=6"
          alt="Buy Me a Coffee at ko-fi.com"
        />
      </a>
    </header>
  );
}
